import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LoginPage, VerifyLoginPage, ForgotPasswordPage } from "./modules/stockpick-login";
import { RegisterPage } from "./modules/stockpick-register";
import { IntroPage, PreviewPage } from "./modules/stockpick-intro";
import { EkycPage } from "./modules/stockpick-ekyc";
import { PersonalHealthCheckPage } from "./modules/stockpick-health-check";
import { InvestmentMethodPage, ValueInvestmentPage, TrendingInvestmentPage } from "./modules/stockpick-investment-method";
import { PackagePage } from "./modules/stockpick-package";
import { PaymentPage } from "./modules/stockpick-payment";
import { Header, PrivateRoute } from "./modules/common";
import { Provider } from "react-redux";
import store, { persistor } from "./modules/base/redux/store";
import './App.css';

// import ReactGA from 'react-ga';
// ReactGA.initialize('UA-237026000-1');
// ReactGA.pageview(window.location.pathname + window.location.search);


function App() {
  return (
    <div className="App">
      <Provider store={store}>
        <BrowserRouter>
          <Header />
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/login/verify" element={<VerifyLoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/" element={<IntroPage />} />
            <Route path="/preview" element={<PreviewPage />} />
            <Route path="/tools/skdm" element={<EkycPage />} />
            <Route path="/tools/sktccn" element={<PersonalHealthCheckPage />} />
            <Route path="/investment-method" element={<InvestmentMethodPage />} />
            <Route path="/investment-method/value" element={<ValueInvestmentPage />} />
            <Route path="/investment-method/trending" element={<TrendingInvestmentPage />} />
            <Route path="/packages" element={<PackagePage />} />
            <Route element={<PrivateRoute />}>
              <Route path="/payment" element={<PaymentPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </Provider>
    </div>
  );
}

export default App;
